import { render, staticRenderFns } from "./TournamentOrganizer.vue?vue&type=template&id=9891a7fa&"
import script from "./TournamentOrganizer.vue?vue&type=script&lang=ts&"
export * from "./TournamentOrganizer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports